// ADF node types that only ever wrap other content — a document built solely
// from these plus whitespace text is considered empty.
const CONTAINER_ADF_TYPES = new Set(['doc', 'paragraph']);

/** True when an ADF node holds non-whitespace text or any non-container node. */
const nodeHasContent = (node: unknown): boolean => {
	if (!node || typeof node !== 'object') {
		return false;
	}
	const { type, text, content } = node as {
		type?: string;
		text?: string;
		content?: unknown[];
	};
	if (type === 'text') {
		return typeof text === 'string' && text.trim().length > 0;
	}
	// A non-text, non-container node (media, mention, emoji, inline card, …) is
	// itself meaningful content.
	if (type && !CONTAINER_ADF_TYPES.has(type)) {
		return true;
	}
	return Array.isArray(content) && content.some(nodeHasContent);
};

/**
 * True when an ADF document has no real content — i.e. it is empty or contains
 * only whitespace text (e.g. the user typed spaces). Used so a whitespace-only
 * rich-text value (comment / description / justification) is treated as empty
 * and never stored.
 *
 * Mirrors the Focus product's `isDocumentEmpty`, but works directly on ADF JSON
 * and trims text, so `" "` counts as empty (the public editor utils don't).
 */
export const isEditorDocumentEmpty = (node: unknown): boolean => !nodeHasContent(node);
